import { StandardDataTable } from "./StandardDataTable";
import type { ColumnDef } from "@tanstack/react-table";

type PermissionRow={id:string;module:string;permission:string;enabled:boolean};

export function StandardPermissionTable({permissions,selected,onChange}:{permissions:string[];selected:ReadonlySet<string>;onChange:(permissions:Set<string>)=>void}){
 const rows:PermissionRow[]=permissions.map(permission=>({id:permission,module:permission.split(".")[0]??"platform",permission,enabled:selected.has(permission)}));
 const columns:ColumnDef<PermissionRow>[]=[
  {accessorKey:"module",header:"Modulo"},
  {accessorKey:"permission",header:"Permesso"},
  {id:"enabled",header:"Assegnato",accessorFn:row=>row.enabled?"Sì":"No",cell:context=>{const permission=context.row.original.permission;return <input type="checkbox" aria-label={`Assegna ${permission}`} checked={selected.has(permission)} onClick={event=>event.stopPropagation()} onKeyDown={event=>event.stopPropagation()} onChange={event=>{const next=new Set(selected);event.target.checked?next.add(permission):next.delete(permission);onChange(next)}}/>}},
 ];
 return <StandardDataTable caption="Permessi del ruolo" columns={columns} rows={rows}/>;
}
